import { render, staticRenderFns } from "./DadosContato.vue?vue&type=template&id=64f48e35&scoped=true"
import script from "./DadosContato.vue?vue&type=script&lang=js"
export * from "./DadosContato.vue?vue&type=script&lang=js"
import style0 from "./DadosContato.vue?vue&type=style&index=0&id=64f48e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f48e35",
  null
  
)

export default component.exports